import { render, staticRenderFns } from "./AlarmItem.vue?vue&type=template&id=98aa3a7c&scoped=true"
import script from "./AlarmItem.vue?vue&type=script&lang=js"
export * from "./AlarmItem.vue?vue&type=script&lang=js"
import style0 from "./AlarmItem.vue?vue&type=style&index=0&id=98aa3a7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98aa3a7c",
  null
  
)

export default component.exports